import React, { useMemo } from 'react';
import { WaveSurferPlayer } from "./WaveSurferPlayer";

export function ProjectContentPlayer({projectContentId,
                                      fileUrl, 
                                      startsIn,
                                      isUseful,
                                      metadataDurationCentiseconds,
                                      ownerId,
                                      showYesNoRemoveProjectFunction,
                                      functionProjectIdToRemove,
                                      setShowInfoModal,
                                      setShowToggleBoxComments,
                                      functionSetIdToShowInfo,
                                      boxCommentsOpened,
                                      setProjectContentToComment}: any){

    return (
      <>
        <WaveSurferPlayer
          projectContentId={projectContentId}
          startsIn={startsIn}
          metadataDurationCentiseconds={metadataDurationCentiseconds}
          ownerId={ownerId}
          url={fileUrl}
          isUseful={isUseful}
          handleShowYesNoModal={showYesNoRemoveProjectFunction}
          handleSetProjectIdToRemove={functionProjectIdToRemove}
          handleSetShowProjectContenInfoModal={setShowInfoModal}
          handleShowToggleBoxComments={setShowToggleBoxComments}
          handleSetIdToShowInfo={functionSetIdToShowInfo}
          boxCommentsOpened={boxCommentsOpened}
          setProjectContentToComment={setProjectContentToComment}
        />
      </>
    )
  }